import { v4 as uuid } from "uuid";

export const categories = [
  {
    _id: uuid(),
    categoryName: "Eargasm",
    category: "eargasm",
  },
  {
    _id: uuid(),
    categoryName: "Review",
    category: "review",
  },
  {
    _id: uuid(),
    categoryName: "Adrenaline Rush",
    category: "adrenaline-rush",
  },
  {
    _id: uuid(),
    categoryName: "Isle Of Man",
    category: "isle-of-man",
  },
];
